import { useState } from "react";
import Accordion from "./_Accordion";
import Loading from "./_Loading";
import TablePagination from "./_TablePagination";

/**
 * 
 * @param {{companies: Array, loading: boolean}} param0 
 * @returns 
 */
export default function CompaniesList({companies, loading}) {
    const [page, setPage] = useState(1);
    const itemsPerPage = 25;

    const updateTablePage = function(toPage) {
        setPage(toPage);
    }

    return (
        <>
            <Loading isLoading={loading} />
            {companies.length > 0 && !loading && (
                <>
                    <h2 id="titleCvm" className="pages__subtitle">{companiesTxt}</h2>

                    <ul className="pageCVM__companies">
                        {loading === false &&
                            companies.slice(itemsPerPage * (page - 1), itemsPerPage * page).map(company => 
                                <Accordion
                                    key={`${company.codigo_cvm}_${company.nome}_${company.setor}`}
                                    company={company}
                                    cvmCode={company.codigo_cvm}
                                />
                            )
                        }
                    </ul>
                    <TablePagination
                        itemsPerPage={itemsPerPage}
                        amount={companies.length}
                        currentPage={page}
                        updateTablePage={updateTablePage}
                    />
                    <div id="listagem"></div>
                </>
            )}
        </>
    );
}